import { useState, useEffect, useRef } from "react";

const { Typography } = require("@mui/material");

const Countdown = ({ expiryTime, callBackTimer, defaultM = 3 }) => {
  const [start, setStart] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!expiryTime) return;

    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      const now = new Date().getTime();
      const diffTime = expiryTime - now;

      if (diffTime <= 0) {
        setMinutes(0);
        setSeconds(0);
        clearInterval(intervalRef.current);
        if (expiryTime > 0) {
          callBackTimer(true);
        }
      } else {
        setMinutes(Math.floor(diffTime / (60 * 1000)));
        setSeconds(Math.floor(diffTime / 1000 % 60));
      }
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [expiryTime]);

  useEffect(() => {
    if (!start && seconds > 0) {
      setStart(true);
    }
  }, [seconds]);

  return (
    <>
      {
        start &&
        <Typography fontSize={14} fontWeight={500} color={"black"}>
          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </Typography>
      }
    </>
  )
}

export default Countdown;